module.exports = __webpack_public_path__ + "static/media/paisa.e42cf22c.png";